import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faArrowDown, faArrowUp } from "@fortawesome/free-solid-svg-icons";
import React from 'react'

export const OrderColumns = (props) => {
    const { label, onClickDesc, onClickAsc, sortBy, sortDir }=props
  return (
    <div className="flex">
          {label}
          &nbsp;
          <div className="flex margin-auto">
            {sortDir=="desc" ?
                <FontAwesomeIcon className="blue cursor-pointer margin-auto" onClick={onClickAsc} icon={faArrowUp} />
                :
                <FontAwesomeIcon className="blue cursor-pointer margin-auto" onClick={onClickDesc} icon={faArrowDown} />
            }
          </div>
    </div>
  )
}
